import { DocumentTitleOverridersContext } from "@redotech/redo-marketplace-app-common/title";
import {
  BreadcrumbOverriders,
  BreadcrumbOverridersContext,
  useBreadcrumbs,
} from "@redotech/redo-web/breadcrumb";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { memo, useContext, useMemo, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { useDocumentTitle } from "usehooks-ts";

const hideBannerPaths = ["/login", "/auth/verify"];

const RouterRootInner = memo(function RouterRootInner() {
  const breadcrumbs = useBreadcrumbs();
  const location = useLocation();

  const [documentTitleOverriders] = useContext(DocumentTitleOverridersContext);
  const title = useMemo(() => {
    if (documentTitleOverriders && documentTitleOverriders.size > 0) {
      const firstOverrider = Array.from(documentTitleOverriders.values())[0];
      return firstOverrider(breadcrumbs || []);
    }
    return breadcrumbs
      ? `${breadcrumbs.map((breadcrumb) => breadcrumb.name).join(" ")} — Redo Marketplace`
      : "Redo Marketplace";
  }, [breadcrumbs, documentTitleOverriders]);

  const isAuthPage = useMemo(() => {
    return hideBannerPaths.some((path) => location.pathname.startsWith(path));
  }, [location.pathname]);

  useDocumentTitle(title);

  return (
    <div className="h-screen flex flex-col overflow-hidden">
      {!isAuthPage && (
        <Flex
          align="center"
          justify="center"
          px="sm"
          py="sm"
          style={{ backgroundColor: "#000000", flexShrink: 0 }}
          w="full"
        >
          <Text color="white" fontSize="sm">
            Shop great deals. New deals added daily. Free shipping on orders
            over $300.
          </Text>
        </Flex>
      )}
      <div className="flex-1 overflow-auto">
        <Outlet />
      </div>
    </div>
  );
});

export const RouterRoot = memo(function RouterRoot() {
  const [breadcrumbOverriders, setBreadcrumbOverriders] =
    useState<BreadcrumbOverriders>(new Map());
  const [documentTitleOverriders, setDocumentTitleOverriders] = useState(
    new Map(),
  );
  return (
    <BreadcrumbOverridersContext.Provider
      value={[breadcrumbOverriders, setBreadcrumbOverriders]}
    >
      <DocumentTitleOverridersContext.Provider
        value={[documentTitleOverriders, setDocumentTitleOverriders]}
      >
        <RouterRootInner />
      </DocumentTitleOverridersContext.Provider>
    </BreadcrumbOverridersContext.Provider>
  );
});
